import { getCookie } from "../state/cookie";

export const COOKIE_NAME = "__esc_client_settings";

export const DEFAULTS = Object.freeze({
	tracking: true,
	metrics: true,
	adsense: true,
});

export function parseCookie(value) {
	let parsed;

	try {
		parsed = JSON.parse(value);
	} catch {
		return DEFAULTS;
	}

	if (parsed === null || typeof parsed !== "object") {
		return DEFAULTS;
	}

	return Object.freeze(
		Object.fromEntries(
			Object.entries(DEFAULTS).map(([key, def]) => [
				key,
				parsed.hasOwnProperty(key) ? Boolean(parsed[key]) : def,
			]),
		),
	);
}

const settings = parseCookie(getCookie(COOKIE_NAME));

export const hasTracking = settings.tracking;
export const hasMetrics = settings.metrics;
export const hasAdsense = settings.adsense;
